import styled from 'styled-components';

export const StyledWrapper = styled.div`
  height: 100%;
  background-color: #fff;

  p {
    margin: 0 0 8px;
  }

  p:empty {
    display: none;
  }

  h1,
  h2,
  h3,
  h4 {
    margin: 0 0 8px;
    line-height: 1.3;
  }

  ol,
  ul {
    margin: 8px 0;
    padding-left: 24px;
  }

  li {
    margin-bottom: 8px;
  }

  li:last-child {
    margin-bottom: 0;
  }

  li > p {
    margin: 0 0 4px;
  }

  .katex-display {
    margin: 6px 0;
  }

  .markdown-content {
    font-size: 14px;
    line-height: 20px;
  }

  .cursor {
    display: inline-block;
    width: 1px;
    background-color: black;
    animation: blink 0.7s step-end infinite;
  }

  .table-container {
    margin: 16px 0;
    .table-title {
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      color: #000;
      margin-bottom: 4px;
    }
  }

  .table {
    overflow: auto;
    max-height: 400px;
    position: relative;

    table {
      border: 1px solid #f1f3f5;
      thead {
        tr {
          th {
            padding: 10px 12px;
            color: #495057;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            background: #f8f9fa;
            white-space: nowrap;
            text-align: left;
            position: sticky;
            top: 0;
            &:first-child {
              width: 50px;
              text-align: center;
            }
            &:nth-child(2) {
              min-width: 200px;
            }
          }
        }
      }
      tbody {
        tr {
          td {
            padding: 8px 12px;
            color: #000;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            border-bottom: 1px solid #f1f3f5;
            border-right: 1px solid #f1f3f5;
            /* background: #fff;
            &:first-child {
              left: 0;
              position: sticky;
            } */
            white-space: nowrap;
            &:first-child {
              width: 50px;
              text-align: center;
            }
          }
        }
      }
    }
  }
  @keyframes blink {
    from,
    to {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
  }
`;
